// Copy text to the clipboard, working in BOTH secure and non-secure contexts.
//
// navigator.clipboard is only defined in a "secure context" (HTTPS, or localhost).
// When the app is served over plain HTTP on a LAN IP (e.g. http://192.168.2.123:8080),
// navigator.clipboard is undefined and `navigator.clipboard.writeText(...)` throws, so the
// Copy / Copy-as-HTML actions silently fail. We fall back to the legacy hidden-textarea +
// document.execCommand('copy') technique, which still works without a secure context.
//
// Returns true on success, false on failure (so callers can pick the right notification).
export async function copyToClipboard(text) {
    const value = text == null ? '' : String(text)

    if (navigator.clipboard && window.isSecureContext) {
        try {
            await navigator.clipboard.writeText(value)
            return true
        } catch (e) {
            // fall through to the legacy path (e.g. permissions/denied)
        }
    }

    // Legacy fallback: a temporary, off-screen textarea we select and copy from.
    try {
        const textarea = document.createElement('textarea')
        textarea.value = value
        textarea.setAttribute('readonly', '')
        textarea.style.position = 'fixed'
        textarea.style.top = '-9999px'
        textarea.style.left = '-9999px'
        textarea.style.opacity = '0'
        document.body.appendChild(textarea)
        textarea.focus()
        textarea.select()
        textarea.setSelectionRange(0, value.length)
        const ok = document.execCommand('copy')
        document.body.removeChild(textarea)
        return ok
    } catch (e) {
        return false
    }
}

export default copyToClipboard
